import { render, staticRenderFns } from "./PlayerBubble.vue?vue&type=template&id=efa3397e&scoped=true&"
import script from "./PlayerBubble.vue?vue&type=script&lang=js&"
export * from "./PlayerBubble.vue?vue&type=script&lang=js&"
import style0 from "./PlayerBubble.vue?vue&type=style&index=0&id=efa3397e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa3397e",
  null
  
)

export default component.exports